import { get } from 'lodash';

export default ['$scope', '$routeParams', '$location', '$window', 'AccountApplicationV1', 'users', 'Comment', 'Client', 'Agreement', 'StaffAccountApplication', 'PortfolioModels',
  function ($scope, $routeParams, $location, $window, AccountApplicationV1, users, Comment, Client, Agreement, StaffAccountApplication, PortfolioModels) {
    StaffAccountApplication.get($routeParams, (application) => {
      this.accountApplication = application.accountApplication;
      this.clientProfile = application.clientProfile;
      this.user = application.user;
      this.rc518Updated = application.rc518Updated;
      this.pmName = `${this.accountApplication.pmFirstName} ${this.accountApplication.pmLastName}`;
      this.income = get(this, 'accountApplication.answers.income');
      const incomeToNetWorthRatioValue = this.income / this.accountApplication.netWorth;
      this.incomeToNetWorthRatio = incomeToNetWorthRatioValue.toFixed(3);
      this.isTemporarySIN = application.clientProfile.taxId && application.clientProfile.taxId[0] === '9';
      this.eidCheckStatus = application.userEidCheckStatus
      this.watchlistCheckStatus = application.userWatchlistCheckStatus

      const birthday = moment(this.clientProfile.dateOfBirth);
      const dateNow = moment(new Date());
      this.age = dateNow.diff(birthday, 'years');

      if (this.accountApplication.agreementSignatureId) {
        this.agreementURL = this.accountApplication.agreementSignatureId;
      }

      const answers = get(this, 'accountApplication.answers');
      if (answers && answers.investorSuitability != null) {
        this.investorSuitability = Object.keys(answers.investorSuitability)
          .sort()
          .map(key => ({
            question: answers.investorSuitability[key].question,
            value: answers.investorSuitability[key].value,
          }))
          // We're no longer committing 'Recommended Portfolio' to the DB,
          // but we need to filter it out of older applications
          .filter(key => key.question !== 'Recommended Portfolio');
        this.earlyWithdrawal = answers.earlyWithdrawal;
      }

      const roundToThousandth = num => Math.round(num * 1000) / 1000;

      const suitabilityScoreAsFloat = parseFloat(this.accountApplication.suitabilityScore) || 0;
      this.suitabilityScoreRounded = roundToThousandth(suitabilityScoreAsFloat);

      const portfolioModelId = get(this, 'accountApplication.answers.portfolioModelId');
      if (portfolioModelId) {
        PortfolioModels.get(
          { id: portfolioModelId },
          (selectedPortfolio) => {
            this.portfolioRisk = selectedPortfolio.risk;
          },
        );
      }

      this.suitabilityScoreVsPortfolioScore = () => {
        if (this.portfolioRisk !== undefined
          && this.accountApplication.suitabilityScore !== undefined) {
          return this.accountApplication.suitabilityScore >= this.portfolioRisk;
        }

        return false;
      };

      const maritalStatus = get(this, 'accountApplication.answers.maritalStatus');
      if (maritalStatus) {
        this.hasSpouse = ['married', 'common'].includes(maritalStatus);
      }
    });

    this.userId = users.getCurrentUser().id;

    this.loadComments = () => AccountApplicationV1.getComments($routeParams).$promise
      .then((comments) => {
        this.accountApplication.comments = comments.map(this.processComment);
      });

    this.statusClass = () => {
      switch (this.accountApplication && this.accountApplication.status) {
        case 'incomplete': return 'text-warning';
        case 'processed': return 'text-highlight';
        default: return 'text-primary';
      }
    };

    this.setState = (state) => {
      return AccountApplicationV1.state({ id: this.accountApplication.id, state })
      .$promise.then(() => {
        this.accountApplication.status = state;
        this.accountApplication.comments = AccountApplicationV1.getComments($routeParams);
        return this.accountApplication.comments;
      });
    };

    this.cancel = () => confirm('Are you sure you want to delete the application?')
        && AccountApplicationV1.delete(
          { id: this.accountApplication.id },
          () => $window.history.back());

    this.saveFintrac = () => {
      delete this.fintracError;
      $scope.fintracForm.$setPristine();
      return Client.update(
        {
          id: this.user.id,
          fintrac: {
            risk: this.clientProfile.fintrac.risk,
            flagged: this.clientProfile.fintrac.flagged,
            reported: this.clientProfile.fintrac.reported,
          },
        }).$promise.catch((e) => {
          this.fintracError = e.data;
        });
    };

    this.saveAccountNumber = () => {
      delete this.accountNumberError;
      $scope.accountNumberForm.$setPristine();
      return AccountApplicationV1.update({
        id: this.accountApplication.id,
        accountNumber: this.accountApplication.accountNumber,
      })
      .$promise.catch((e) => {
        this.accountNumberError = e.data;
      });
    };

    this.pmApprovalToggle = () => {
      let pmApproved;
      let pmBy;
      let pmDate;
      delete this.pmApprovalError;
      if (this.accountApplication.pmApproval) {
        pmApproved = !this.accountApplication.pmApproval.approved;
      } else {
        pmApproved = true;
      }
      if (pmApproved) {
        pmDate = new Date();
        pmDate = pmDate.toISOString();
        pmBy = users.getCurrentUser().id;
      } else {
        pmDate = null;
        pmBy = null;
      }
      return AccountApplicationV1.update(
        {
          id: this.accountApplication.id,
          pmApproval: { approved: pmApproved, by: pmBy, at: pmDate },
        },
      ).$promise.then((a) => {
        this.accountApplication.pmApproval = a.pmApproval;
        this.pmName = a.pmApproval.pmName;
        return this.pmName;
      }).catch((e) => {
        this.pmApprovalError = e.data;
      });
    };

    this.processComment = comment => ({
      content: comment.content,
      createdAt: comment.createdAt,
      html: comment.html,
      id: comment.id,
      userFirstName: comment.user ? comment.user.firstName : null,
      userId: comment.user ? comment.user.id : null,
      userLastName: comment.user ? comment.user.lastName : null,
    });

    this.addComment = () => {
      if (!this.addCommentWait) {
        this.addCommentWait = true;
        return AccountApplicationV1.addComment({
          id: this.accountApplication.id,
          content: this.newComment,
        }).$promise.then((comment) => {
          this.newComment = null;
          return this.accountApplication.comments.push(this.processComment(comment));
        }).catch((e) => {
          this.newCommentError = e.data;
        }).finally(() => {
          this.addCommentWait = false;
        });
      }

      return undefined;
    };

    this.editComment = (comment) => {
      this.accountApplication.comments.forEach(c => (c.isEditing = false));
      comment.isEditing = true;
    };

    this.saveComment = (comment) => {
      if (!this.saveCommentWait) {
        this.saveCommentWait = true;
        return Comment.update(comment).$promise.then((updatedComment) => {
          _.assign(comment, this.processComment(updatedComment));
          comment.isEditing = false;
        }).catch((e) => { this.commentError = e.data; })
        .finally(() => { this.saveCommentWait = false; });
      }

      return undefined;
    };

    this.deleteComment = commentId => Comment.delete({ id: commentId })
      .$promise.then(() => this.loadComments());

    this.gotoDocuments = () => $location.path(`/clients/${this.user.id}/documents`);

    this.rebuildAgreement = (accountApplicationId, agreementId) =>
      Agreement.delete({ id: agreementId }, () =>
        Agreement.create(
          { account_application_id: accountApplicationId },
          () => location.reload(true),
        ),
      );

    this.preApplicationFundingTracking = accountApplication => accountApplication && accountApplication.submittedAt && moment(accountApplication.submittedAt) < moment('2018-06-07T12:00:00.000Z');

    this.bankAccountInfo = () => {
      const answers = get(this, 'accountApplication.answers');
      if (get(answers, 'bankCode')) {
        return `${answers.bankBranchNumber} ${answers.bankCode} ${answers.bankAccountNumber}`;
      }
      return 'No banking info provided / linked';
    };

    this.bankInitialDepositAmount = () => {
      const answers = get(this, 'accountApplication.answers');
      if (get(answers, 'depositInitialAmount')) {
        return `One Time: @ $${answers.depositInitialAmount}`;
      } else if (
        !get(answers, 'depositRecurringAmount')
        && !get(answers, 'depositInitialAmount')
      ) {
        return 'No';
      }

      return 'No initial deposit requested';
    };

    this.bankRecurringDepositFrequency = () => {
      switch (get(this, 'accountApplication.answers.depositRecurringFrequency')) {
        case '52': return 'weekly';
        case '26': return 'bi-weekly';
        case '24': return 'twice a month';
        case '12': return 'monthly';
        case '4': return 'quarterly';
        default: return undefined;
      }
    };

    this.bankRecurringDepositPlan = () => {
      const answers = get(this, 'accountApplication.answers');
      if (get(answers, 'depositRecurringAmount')) {
        return `Recurring: $${this.accountApplication.answers.depositRecurringAmount} ${this.bankRecurringDepositFrequency()}`;
      } else if (
        !get(answers, 'depositRecurringAmount')
        && !get(answers, 'depositInitialAmount')
      ) {
        // If there are no deposits of either kind, the 'initial deposit' line will say none
        // and this line will simply be omitted
        return undefined;
      }

      return 'No recurring deposit requested';
    };

    this.spousalApplication = () => {
      if (this.hasSpouse) {
        const accountsNeedingSpousalSin = ['spousal', 'spousal_rrif', 'gsrsp'];

        return accountsNeedingSpousalSin.includes(this.accountApplication.accountType);
      }

      return false;
    };

    return this;
  },
];
